module.exports = __webpack_public_path__ + "img/d6a01ba.jpg";